import {
    BoundaryPartRequestBoundaryType as BOUNDARY_PART_REQUEST_BOUNDARY_TYPE,
    BoundaryPartRequestGeometryType as BOUNDARY_PART_REQUEST_GEOMETRY_TYPE
} from 'generatedTypes/flight/models';

import { DRAWING_MODE } from 'components/Map/hooks/useDrawingTool/constants';
import {
    GEOJSON_BOUNDARY_TYPE,
    GEOJSON_POLYGON_TYPE
} from 'components/Map/hooks/useFeatures/constants';

export {
    GEOJSON_POLYGON_TYPE,
    GEOJSON_PROPERTY,
    GEOJSON_BOUNDARY_TYPE
} from 'components/Map/hooks/useFeatures/constants';

export { GEOJSON_FEATURE_TYPE } from 'components/Map/hooks/useFeatures/constants';

export {
    BoundaryPartRequestGeometryType as BOUNDARY_PART_REQUEST_GEOMETRY_TYPE,
    BoundaryPartRequestBoundaryType as BOUNDARY_PART_REQUEST_BOUNDARY_TYPE
} from 'generatedTypes/flight/models';

export const GEOMETRY_TYPE_MAP = {
    [GEOJSON_POLYGON_TYPE.CIRCLE]: BOUNDARY_PART_REQUEST_GEOMETRY_TYPE.CIRCLE,
    [GEOJSON_POLYGON_TYPE.POLYGON]: BOUNDARY_PART_REQUEST_GEOMETRY_TYPE.POLYGON
};

export const GEOJSON_PROPERTY_MAP = {
    [BOUNDARY_PART_REQUEST_GEOMETRY_TYPE.CIRCLE]: GEOJSON_POLYGON_TYPE.CIRCLE,
    [BOUNDARY_PART_REQUEST_GEOMETRY_TYPE.POLYGON]: GEOJSON_POLYGON_TYPE.POLYGON
};

export const BOUNDARY_TYPE_MAP = {
    [BOUNDARY_PART_REQUEST_BOUNDARY_TYPE.APPLY]: GEOJSON_BOUNDARY_TYPE.APPLY,
    [BOUNDARY_PART_REQUEST_BOUNDARY_TYPE.NO_ENTRY]: GEOJSON_BOUNDARY_TYPE.NO_ENTRY,
    [BOUNDARY_PART_REQUEST_BOUNDARY_TYPE.NO_APPLY]: GEOJSON_BOUNDARY_TYPE.NO_APPLY
};

export const DRAWING_MODE_TO_BOUNDARY_TYPE_MAP = {
    [DRAWING_MODE.APPLY]: BOUNDARY_PART_REQUEST_BOUNDARY_TYPE.APPLY,
    [DRAWING_MODE.NO_ENTRY]: BOUNDARY_PART_REQUEST_BOUNDARY_TYPE.NO_ENTRY
};
